import { obterHorimetroKMAsync } from "../../services/horimetroKMService";

const atualizarHorimetroKMs = async ({ commit }) => {
    const horimetroKMs = await obterHorimetroKMAsync();
    commit('atualizarHorimetroKMs', horimetroKMs);
}

const atualizarHorimetroKM = ({ commit }, horimetroKM) => {
    commit('atualizarHorimetroKM', horimetroKM);
}

export default {
    atualizarHorimetroKMs,
    atualizarHorimetroKM
}